import React from 'react'

import { SelectDropdown } from '../../../../../components/SelectDropdown/SelectDropdown'

import { ManualParticipantAddedReason } from '../../../../../models/ManualParticipant'

import { getManualParticipantReasonOptions } from './utils'

export interface ManualParticipantReasonFieldsProps {
  reason: ManualParticipantAddedReason | null
  otherExplanation: string
  onReasonSelected: (reason: ManualParticipantAddedReason) => void
  onOtherExplanationChange: (value: string) => void
  showConsentWarning?: boolean
  consentWarningText?: string
  otherOptionLabel?: string
  reasonPlaceholder?: string
  otherExplanationPlaceholder?: string
  dropdownWrapperClassName?: string
  dropdownClassName?: string
  explanationWrapperClassName?: string
  warningWrapperClassName?: string
}

export const ManualParticipantReasonFields: React.FC<ManualParticipantReasonFieldsProps> = ({
  reason,
  otherExplanation,
  onReasonSelected,
  onOtherExplanationChange,
  showConsentWarning = false,
  consentWarningText,
  otherOptionLabel = 'Other',
  reasonPlaceholder = 'Select reason',
  otherExplanationPlaceholder = 'Other explanation',
  dropdownWrapperClassName = '',
  dropdownClassName = 'py-2 zocks-px-0.75 zocks-gap-3',
  explanationWrapperClassName = '',
  warningWrapperClassName = '',
}) => {
  const reasonOptions = getManualParticipantReasonOptions(otherOptionLabel)
  const selectedReasonOption = reason ? (reasonOptions.find((option) => option.id === reason) ?? null) : null

  return (
    <>
      <div className={dropdownWrapperClassName}>
        <SelectDropdown
          className={dropdownClassName}
          options={reasonOptions}
          initialSelectedOption={selectedReasonOption}
          onOptionSelected={(selectedOption) => onReasonSelected(selectedOption.id as ManualParticipantAddedReason)}
          placeholder={reasonPlaceholder}
          clearDropdownOnOptionSelected={false}
        />
      </div>

      {reason === ManualParticipantAddedReason.OTHER ? (
        <div className={explanationWrapperClassName}>
          <input
            type='text'
            className='form-control'
            placeholder={otherExplanationPlaceholder}
            value={otherExplanation}
            onChange={(e) => onOtherExplanationChange(e.target.value)}
          />
        </div>
      ) : null}

      {showConsentWarning && consentWarningText ? (
        <div className={warningWrapperClassName}>
          <div className='d-flex align-items-center zocks-gap-0.75 zocks-text-warning-text zocks-bg-color-warning zocks-border-color-warning-dark rounded-3 zocks-px-0.75 py-2'>
            <i className='bi bi-exclamation-triangle fs-6 ' />
            <span className='paragraph-small'>{consentWarningText}</span>
          </div>
        </div>
      ) : null}
    </>
  )
}
